module.exports = __webpack_public_path__ + "img/defaultAvatar.4140fefe.png";